<template>
  <div class="categories" id="categories">
    <div class="container">
      <div class="categories__wrapper">
        <div class="categories__main">
          <router-link
              :to="translations.i18nRoute({ name: 'market', query: { categoriesSlugs: category.node.slug } })"
              class="categories__main-item"
              v-for="category in categories"
              :key="category.node.uuid"
          >
            <div>
              <img :src="category.node.image" :alt="category.node.name">
            </div>
            <p>{{ category.node.name }}</p>
          </router-link>
        </div>
        <ui-button>
          <router-link :to="translations.i18nRoute({ name: 'market' })">
            {{ t('buttons.viewAll') }}
          </router-link>
          <img src="@icons/arrowRight.svg" alt="arrowRight" />
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useCategoryStore} from "@/stores/category.js";
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";
import UiButton from "@/components/ui/ui-button.vue";

const {t} = useI18n()
const categoryStore = useCategoryStore()

const categories = computed(() => categoryStore.categories)
</script>

<style lang="scss" scoped>

.container{
  max-width: 100vw;
}

.categories {
  margin-top: -100px;
  position: relative;
  z-index: 10;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 35px;
  }

  &__top {
    border-bottom: 1px solid #1E1E1E;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & a {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px;
      background-color: transparent;
      transition: 0.2s;

      color: #D9D9D9;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;

      & svg {
        transition: 0.2s;
      }

      @include hover {
        & svg {
          transform: rotate(1turn);
        }
      }
    }
  }

  &__title {
    padding-bottom: 10px;
    border-bottom: 3px solid #3b3b3b;
    color: #D9D9D9;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;

    & span {
      color: #3b3b3b;
    }
  }

  &__main {
    margin-top: 30px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 21px;

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      cursor: pointer;
      overflow: hidden;
      padding: 5px;


      & div {
        background-color: #F5F5F5;
        border: #DD6196 solid 1px;
        border-radius: 15px;
        padding: 15px;
        width: 115px;
        height: 115px;
        display: grid;
        place-items: center;
        transition: 0.2s;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);


        & img {
          width: 100%;
        }
      }

      & p {
        transition: 0.2s;
        color: black;
        text-align: center;
        font-weight: 500;
        line-height: 20px;
      }

      @include hover {
        & div {
          background-color: #FFFFFF;
          box-shadow: 0 0 5px 1px #DD6196;
        }

        & p {
          color: #DD6196;
        }
      }
    }
  }
  &__explore{
    color: #3B3B3B;
    font-size: 21px;
    font-weight: 400;

    border: 1px solid #DD6196;
    padding: 13px 20px;
    border-radius: 27px;
    transition: 0.3s;

    &:hover {
      box-shadow: 0 0 5px 1px #DD6196;
    }

    & a{
      white-space: nowrap;
      display: flex;
      align-items: center;
      gap: 15px;
    }

  }
}

@media (max-width: 1100px){
  p{
    font-size: 14px;
  }
  .categories {
    margin-top: -200px;
  }
}

@media (max-width: 750px) {
  .categories {

    &__title {
      padding-bottom: 5px;
      font-size: 20px;
    }

    &__main {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      margin-top: unset;
    }
  }
}
</style>